export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.spap.pt/api"
    : "http://localhost:8000/api";
